import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'MoneyInput' }

import { computed, type PropType } from 'vue'
import { getCurrencyInfo, getGroupSettings } from '@/util/currencyFormat'

// `numberFormat` is intentionally omitted: el-input-number does not honor
// EU-style comma decimal separators without a formatter/parser pair, and the
// existing 9 amount-input call sites don't honor it either. Display sites
// still pass numberFormat to formatCurrency() — that's the right place.
//
// Runtime prop declarations (not TS-only) so nullable props don't emit
// `type: [T, null]` — Vue 2.7's SFC compiler turns `T | null` into a
// literal `null` in the type array, which Vue rejects as a non-constructor.

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: { type: Number as PropType<number | null>, default: null },
  min: { type: Number, default: 0 },
  max: { type: Number, default: Number.MAX_SAFE_INTEGER },
  precision: { type: Number, default: 2 },
  step: { type: Number, default: 1 },
  placeholder: { type: String, default: '0.00' },
  disabled: { type: Boolean, default: false },
  controls: { type: Boolean, default: false },
  error: { type: [Boolean, String] as PropType<boolean | string>, default: false },
  currency: { type: String as PropType<string | null>, default: null },
  currencySymbol: { type: String as PropType<string | null>, default: null },
  currencyFormat: { type: Number as PropType<number | null>, default: null },
  // 'sm' = the 32px row height used inside editable lists (price tiers)
  size: { type: String as PropType<'sm' | 'md'>, default: 'md' }
},
  emits: ["input", "change"],
  setup(__props, { emit }: { emit: ({
  (e: 'input', value: number | null): void
  (e: 'change', value: number | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const groupSettings = computed(() => getGroupSettings())

const resolvedCurrencyCode = computed(
  () => props.currency || groupSettings.value.currency || 'USD'
)

const currencyInfo = computed(() => getCurrencyInfo(resolvedCurrencyCode.value))

const resolvedSymbol = computed(() => props.currencySymbol || currencyInfo.value.symbol)

const isPostfix = computed(() => currencyInfo.value.postfix)

const errorMessage = computed(() => (typeof props.error === 'string' ? props.error : ''))

// el-input-number emits `undefined` (not null) when the field is cleared.
// Coerce so consumers see a clean `null` and the typed signature holds.
function onInput(val: number | null | undefined) {
  emit('input', val == null ? null : val)
}

function onChange(val: number | null | undefined) {
  emit('change', val == null ? null : val)
}

return { __sfc: true,props, emit, groupSettings, resolvedCurrencyCode, currencyInfo, resolvedSymbol, isPostfix, errorMessage, onInput, onChange }
}

})